import Modal from './modal.js';

class GameTest {
    constructor() {
        this.modal = new Modal('gametestModal');
        this.modalElement = document.getElementById('gametestModal');
        this.overlay = document.getElementById('modalOverlay');
        this.closeBtn = document.getElementById('gametestModalClose');
        this.body = document.getElementById('gametestBody');
        this.footer = document.getElementById('gametestFooter');
        this.nextBtn = document.getElementById('gametestNextBtn');
        this.finalBtn = document.getElementById('gametestFinalBtn');
        this.finalBtnText = document.getElementById('gametestFinalBtnText');
        this.title = document.getElementById('gametestTitle');
        
        this.currentStep = 'welcome';
        this.currentQuestionIndex = 0;
        this.answers = [];
        this.questions = [];
        this.games = [];
        this.selectedGames = [];
        this.isThankYouPage = false;
        
        this.init();
    }
    
    init() {
        if (!this.modalElement) return;
        
        this.loadData();
        this.bindEvents();
        this.detectPageType();
    }
    
    detectPageType() {
        const url = window.location.pathname.toLowerCase();
        this.isThankYouPage = url.includes('thankyou') || url.includes('spasibo') || url.includes('thank-you');
    }
    
    loadData() {
        return fetch('/wp-json/pozamezh/v1/gametest-data')
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    this.questions = data.data.questions || [];
                    this.games = data.data.games || [];
                }
                return data;
            })
            .catch(error => {
                return { success: false, error: error };
            });
    }
    
    bindEvents() {
        if (this.closeBtn) {
            this.closeBtn.addEventListener('click', () => this.close());
        }
        
        if (this.overlay) {
            this.overlay.addEventListener('click', () => this.close());
        }
        
        if (this.nextBtn) {
            this.nextBtn.addEventListener('click', () => this.handleNext());
        }
        
        if (this.finalBtn) {
            this.finalBtn.addEventListener('click', () => this.handleFinal());
        }
        
        document.addEventListener('click', (e) => {
            const gametestLink = e.target.closest('.gametest');
            if (gametestLink) {
                e.preventDefault();
                this.open();
            }
        });
    }
    
    open() {
        if (!this.modalElement) return;
        
        this.detectPageType();
        this.reset();
        this.modal.open();
        this.showStep('welcome');
        
        if (this.questions.length === 0 && this.games.length === 0) {
            this.loadData();
        }
    }
    
    close() {
        if (!this.modalElement) return;
        this.modal.close();
    }
    
    reset() {
        this.currentStep = 'welcome';
        this.currentQuestionIndex = 0;
        this.answers = [];
        
        if (this.nextBtn) {
            const nextBtnText = this.nextBtn.querySelector('.btn__text');
            if (nextBtnText) {
                nextBtnText.textContent = 'Підібрати гру';
            }
        }
    }
    
    showStep(step) {
        if (!this.body) return;
        
        const steps = this.body.querySelectorAll('.gametest-step');
        const currentStepEl = this.body.querySelector(`[data-step="${this.currentStep}"]`);
        const nextStepEl = this.body.querySelector(`[data-step="${step}"]`);
        
        if (!nextStepEl) return;
        
        const isQuestionStep = step === 'question';
        const isSameStepType = (this.currentStep === 'question' && step === 'question');
        
        if (currentStepEl && currentStepEl !== nextStepEl) {
            currentStepEl.classList.add('gametest-step--leaving');
            currentStepEl.classList.remove('gametest-step--active');
            
            setTimeout(() => {
                currentStepEl.style.display = 'none';
                currentStepEl.classList.remove('gametest-step--leaving');
                
                nextStepEl.style.display = 'block';
                requestAnimationFrame(() => {
                    nextStepEl.classList.add('gametest-step--active');
                    
                    if (isQuestionStep) {
                        this.showQuestion();
                    } else if (step === 'results') {
                        this.showResults();
                    }
                });
            }, 200);
        } else if (isSameStepType) {
            const questionContainer = this.body.querySelector('.gametest-question');
            if (questionContainer) {
                questionContainer.style.opacity = '0';
                questionContainer.style.transform = 'translateX(20px)';
                
                setTimeout(() => {
                    this.showQuestion();
                    requestAnimationFrame(() => {
                        questionContainer.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
                        questionContainer.style.opacity = '1';
                        questionContainer.style.transform = 'translateX(0)';
                    });
                }, 200);
            }
        } else {
            nextStepEl.style.display = 'block';
            requestAnimationFrame(() => {
                nextStepEl.classList.add('gametest-step--active');
                
                if (isQuestionStep) {
                    this.showQuestion();
                } else if (step === 'results') {
                    this.showResults();
                }
            });
        }
        
        steps.forEach(s => {
            if (s !== nextStepEl && s !== currentStepEl) {
                s.style.display = 'none';
                s.classList.remove('gametest-step--active', 'gametest-step--leaving');
            }
        });
        
        this.currentStep = step;
        this.updateButtons();
        
        if (step === 'welcome') {
            if (this.title) {
                this.title.textContent = 'Підбір ігор';
            }
        }
    }
    
    showQuestion() {
        if (this.currentQuestionIndex >= this.questions.length) {
            this.showStep('results');
            return;
        }
        
        const question = this.questions[this.currentQuestionIndex];
        if (!question) {
            return;
        }
        
        const questionTitle = this.body.querySelector('#gametestQuestionTitle');
        const answersContainer = this.body.querySelector('#gametestQuestionAnswers');
        
        if (!questionTitle) {
            return;
        }
        
        if (!answersContainer) {
            return;
        }
        
        questionTitle.textContent = question.question || '';
        answersContainer.innerHTML = '';
        
        if (question.responses && question.responses.length > 0) {
            question.responses.forEach((response, index) => {
                const responseText = typeof response === 'string' ? response : (response.text || '');
                const answerEl = this.createAnswerElement(responseText, index);
                answersContainer.appendChild(answerEl);
            });
        } else {
            answersContainer.innerHTML = '<p style="color: rgba(255, 255, 255, 0.7); padding: 20px 0;">Відповіді не знайдені</p>';
        }
        
        if (this.title) {
            this.title.textContent = `Питання ${this.currentQuestionIndex + 1} з ${this.questions.length}`;
        }
    }
    
    createAnswerElement(responseText, index) {
        const answerWrapper = document.createElement('div');
        answerWrapper.className = 'gametest-answer';
        
        const radio = document.createElement('input');
        radio.type = 'radio';
        radio.name = `question_${this.currentQuestionIndex}`;
        radio.value = index;
        radio.id = `answer_${this.currentQuestionIndex}_${index}`;
        
        const check = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        check.setAttribute('class', 'gametest-answer__check');
        check.setAttribute('aria-hidden', 'true');
        const use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
        use.setAttribute('href', '#check');
        check.appendChild(use);
        
        const text = document.createElement('span');
        text.className = 'gametest-answer__text';
        text.textContent = responseText || '';
        
        answerWrapper.appendChild(radio);
        answerWrapper.appendChild(check);
        answerWrapper.appendChild(text);
        
        const handleSelect = () => {
            radio.checked = true;
            this.answers[this.currentQuestionIndex] = index;
            this.updateButtons();
            
            const isLastQuestion = this.currentQuestionIndex === this.questions.length - 1;
            
            if (isLastQuestion) {
                setTimeout(() => {
                    this.showStep('results');
                }, 400);
            } else {
                setTimeout(() => {
                    this.currentQuestionIndex++;
                    this.showStep('question');
                }, 400);
            }
        };
        
        radio.addEventListener('change', handleSelect);
        answerWrapper.addEventListener('click', (e) => {
            if (e.target !== radio) {
                e.preventDefault();
                handleSelect();
            }
        });
        
        return answerWrapper;
    }
    
    showResults() {
        const resultsContainer = this.body.querySelector('#gametestResultsGames');
        if (!resultsContainer) return;
        
        resultsContainer.innerHTML = '';
        resultsContainer.style.opacity = '0';
        resultsContainer.style.transform = 'translateY(20px)';
        
        const gameWeights = {};
        
        this.answers.forEach((answerIndex, questionIndex) => {
            const question = this.questions[questionIndex];
            if (!question || !question.responses) return;
            
            const response = question.responses[answerIndex];
            if (!response) return;
            
            const responseGames = response.games || (typeof response === 'string' ? [] : []);
            
            if (Array.isArray(responseGames) && responseGames.length > 0) {
                responseGames.forEach(gameId => {
                    const id = parseInt(gameId);
                    if (!isNaN(id)) {
                        gameWeights[id] = (gameWeights[id] || 0) + 1;
                    }
                });
            }
        });
        
        const sortedGames = Object.keys(gameWeights)
            .map(gameId => ({
                id: parseInt(gameId),
                weight: gameWeights[gameId]
            }))
            .sort((a, b) => b.weight - a.weight)
            .map(item => {
                return this.games.find(g => g.id === item.id);
            })
            .filter(game => game !== undefined);
        
        if (sortedGames.length === 0) {
            resultsContainer.classList.add('gametest-results__games--empty');
            resultsContainer.innerHTML = '<p class="gametest-results__empty">Ігри не знайдені</p>';
            requestAnimationFrame(() => {
                resultsContainer.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
                resultsContainer.style.opacity = '1';
                resultsContainer.style.transform = 'translateY(0)';
            });
            return;
        }
        
        resultsContainer.classList.remove('gametest-results__games--empty');
        
        sortedGames.forEach((game, index) => {
            const gameEl = this.createGameElement(game);
            gameEl.style.opacity = '0';
            gameEl.style.transform = 'translateY(20px)';
            resultsContainer.appendChild(gameEl);
        });
        
        requestAnimationFrame(() => {
            resultsContainer.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
            resultsContainer.style.opacity = '1';
            resultsContainer.style.transform = 'translateY(0)';
            
            const gameElements = resultsContainer.querySelectorAll('.gametest-game');
            gameElements.forEach((el, index) => {
                setTimeout(() => {
                    el.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
                    el.style.opacity = '1';
                    el.style.transform = 'translateY(0)';
                }, index * 100);
            });
        });
        
        if (this.title) {
            this.title.textContent = 'Підібрані ігри';
        }
    }
    
    createGameElement(game) {
        const gameWrapper = document.createElement('div');
        gameWrapper.className = 'gametest-game';
        gameWrapper.dataset.gameId = game.id;
        
        const isSelected = this.selectedGames.includes(game.id);
        if (isSelected) {
            gameWrapper.classList.add('gametest-game--selected');
        }
        
        if (game.image) {
            const image = document.createElement('img');
            image.className = 'gametest-game__image';
            image.src = game.image;
            image.alt = game.title || '';
            image.onerror = function() {
                this.style.display = 'none';
            };
            gameWrapper.appendChild(image);
        }
        
        const checkIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        checkIcon.setAttribute('class', 'gametest-game__check');
        checkIcon.setAttribute('aria-hidden', 'true');
        const use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
        use.setAttribute('href', '#check');
        checkIcon.appendChild(use);
        gameWrapper.appendChild(checkIcon);
        
        const content = document.createElement('div');
        content.className = 'gametest-game__content';
        
        const title = document.createElement('h4');
        title.className = 'gametest-game__title';
        title.textContent = game.title || '';
        
        const features = document.createElement('div');
        features.className = 'gametest-game__features';
        
        if (game.players_num) {
            const playersFeature = document.createElement('div');
            playersFeature.className = 'gametest-game__feature';
            playersFeature.innerHTML = `<strong>Максимальна кількість гравців:</strong> ${game.players_num}`;
            features.appendChild(playersFeature);
        }
        
        if (game.tematic) {
            const tematicFeature = document.createElement('div');
            tematicFeature.className = 'gametest-game__feature';
            tematicFeature.innerHTML = `<strong>Опис:</strong> ${game.tematic}`;
            features.appendChild(tematicFeature);
        }
        
        content.appendChild(title);
        if (features.children.length > 0) {
            content.appendChild(features);
        }
        
        gameWrapper.appendChild(content);
        
        gameWrapper.addEventListener('click', () => {
            this.toggleGameSelection(game.id, gameWrapper);
        });
        
        return gameWrapper;
    }
    
    toggleGameSelection(gameId, gameElement) {
        const index = this.selectedGames.indexOf(gameId);
        
        if (index > -1) {
            this.selectedGames.splice(index, 1);
            gameElement.classList.remove('gametest-game--selected');
        } else {
            this.selectedGames.push(gameId);
            gameElement.classList.add('gametest-game--selected');
        }
    }
    
    updateButtons() {
        if (!this.nextBtn || !this.finalBtn) return;
        
        const nextBtnText = this.nextBtn.querySelector('.btn__text');
        const finalBtnText = this.finalBtn.querySelector('.btn__text');
        
        if (this.currentStep === 'welcome') {
            this.nextBtn.style.display = 'flex';
            if (nextBtnText) {
                nextBtnText.textContent = 'Підібрати гру';
            }
            this.finalBtn.style.display = 'none';
        } else if (this.currentStep === 'question') {
            this.nextBtn.style.display = 'none';
            this.finalBtn.style.display = 'none';
        } else if (this.currentStep === 'results') {
            this.nextBtn.style.display = 'none';
            this.finalBtn.style.display = 'flex';
            
            if (this.isThankYouPage && finalBtnText) {
                finalBtnText.textContent = 'Дякую за пораду';
            } else if (finalBtnText) {
                finalBtnText.textContent = 'ЗАБРОНЮВАТИ ГРУ';
            }
        }
    }
    
    handleNext() {
        if (this.currentStep === 'welcome') {
            if (this.questions.length > 0) {
                this.showStep('question');
            } else {
                this.loadData().then(() => {
                    if (this.questions.length > 0) {
                        this.showStep('question');
                    } else {
                        this.showStep('results');
                    }
                });
            }
        } else if (this.currentStep === 'question') {
            if (this.answers[this.currentQuestionIndex] === undefined) {
                return;
            }
            
            const isLastQuestion = this.currentQuestionIndex === this.questions.length - 1;
            
            if (isLastQuestion) {
                this.showStep('results');
            } else {
                this.currentQuestionIndex++;
                this.showStep('question');
            }
        }
    }
    
    handleFinal() {
        if (this.isThankYouPage) {
            this.close();
        } else {
            this.close();
            setTimeout(() => {
                const bookingSection = document.querySelector('#booking');
                if (bookingSection) {
                    const header = document.querySelector('.header');
                    const headerHeight = header ? header.offsetHeight : 0;
                    const targetRect = bookingSection.getBoundingClientRect();
                    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
                    const targetOffset = targetRect.top + scrollTop - headerHeight;
                    
                    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
                    const isAndroid = /Android/.test(navigator.userAgent);
                    
                    if (isIOS || isAndroid) {
                        let currentScroll = scrollTop;
                        const distance = targetOffset - currentScroll;
                        const duration = 500;
                        const startTime = Date.now();
                        
                        const easeInOutQuad = (t) => {
                            return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
                        };
                        
                        const animateScroll = () => {
                            const elapsed = Date.now() - startTime;
                            const progress = Math.min(elapsed / duration, 1);
                            const eased = easeInOutQuad(progress);
                            
                            currentScroll = scrollTop + (distance * eased);
                            window.scrollTo(0, currentScroll);
                            
                            if (progress < 1) {
                                requestAnimationFrame(animateScroll);
                            } else {
                                window.scrollTo(0, targetOffset);
                            }
                        };
                        
                        requestAnimationFrame(animateScroll);
                    } else {
                        window.scrollTo({
                            top: targetOffset,
                            behavior: 'smooth'
                        });
                    }
                }
            }, 400);
        }
    }
}

export default GameTest;
